module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "related-posts-container"
  }, [_c('p', {
    staticClass: "container-title"
  }, [_vm._v("相關文章")]), _vm._v(" "), _c('swiper', {
    staticClass: "related-posts swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('a', {
    staticClass: "related-posts__post",
    attrs: {
      "href": "https://www.mirrormedia.mg/story/20170630pol002/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "related-posts__leading-img",
    attrs: {
      "src": "https://storage.googleapis.com/mirrormedia-files/assets/images/20170630102147-bcf487088429558fc4a3bcbf3d40f492-desktop.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "related-posts__content-container"
  }, [_c('p', {
    staticClass: "related-posts__title"
  }, [_vm._v("【一鏡到底】凱道流浪記　巴奈專訪之一")]), _vm._v(" "), _c('p', {
    staticClass: "related-posts__description"
  }, [_vm._v("導演齊柏林逝世讓延燒數十年的亞泥爭議重現；金曲獎典禮上不少歌手高舉標語聲援原住民權益；70...")])])])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('a', {
    staticClass: "related-posts__post",
    attrs: {
      "href": "https://www.mirrormedia.mg/story/20170630pol003/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "related-posts__leading-img",
    attrs: {
      "src": "https://storage.googleapis.com/mirrormedia-files/assets/images/20170630102157-a3f676d644dcc44e02b6e8d8eddacb6f-desktop.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "related-posts__content-container"
  }, [_c('p', {
    staticClass: "related-posts__title"
  }, [_vm._v("【一鏡到底】受傷與流浪　巴奈專訪之二")]), _vm._v(" "), _c('p', {
    staticClass: "related-posts__description"
  }, [_vm._v("談起原生家庭，她低聲說：「我的家庭很破碎…」凱道上綠燈亮起，引擎聲屢屢中斷訪談。父親是卡車...")])])])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('a', {
    staticClass: "related-posts__post",
    attrs: {
      "href": "https://www.mirrormedia.mg/story/20170630pol004/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "related-posts__leading-img",
    attrs: {
      "src": "https://storage.googleapis.com/mirrormedia-files/assets/images/20170630102232-b8c0f4012dbfeb51d2207095ae3f6440-desktop.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "related-posts__content-container"
  }, [_c('p', {
    staticClass: "related-posts__title"
  }, [_vm._v("【一鏡到底】鄉愁與憂愁　巴奈專訪之三")]), _vm._v(" "), _c('p', {
    staticClass: "related-posts__description"
  }, [_vm._v("她回憶小時候，「洗溫泉不用花錢，只要鋤頭挖一挖，石頭疊一疊，把溪水流進來、溫度調好，就可以...")])])])]), _vm._v(" "), (_vm.swiperOption.slidesPerView === 1) ? _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }) : _vm._e(), _vm._v(" "), (_vm.swiperOption.slidesPerView === 1) ? _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-470013fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RelatedPost.vue
// module id = 115
// module chunks = 1